import { render, staticRenderFns } from "./TutoringItem.vue?vue&type=template&id=68318afc&scoped=true"
import script from "./TutoringItem.vue?vue&type=script&lang=js"
export * from "./TutoringItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68318afc",
  null
  
)

export default component.exports